import * as React from 'react'

const SvgLogoIcon = (props) => (
  <svg
    width="160"
    height="20"
    viewBox="0 0 160 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4647 19.2815L13.758 15.3169H6.06509L4.35846 19.2815H0L7.92925 0.928711H11.8939L19.8231 19.2815H15.4647ZM9.92469 6.38991L7.61418 11.7198H12.2089L9.92469 6.38991Z"
      fill="#FF692E"
    />
    <path
      d="M21.9529 0.928711H26.0488V19.2815H21.9529V0.928711Z"
      fill="#FF692E"
    />
    <path
      d="M45.4551 7.02005C45.4551 9.9607 44.2911 11.8599 41.9631 12.7176L46.6104 19.2815H41.5693L37.4996 13.4265H34.664V19.2815H30.5681V0.928711H37.5259C40.379 0.928711 42.4095 1.41007 43.6172 2.37278C44.8425 3.33549 45.4551 4.88458 45.4551 7.02005ZM37.6572 9.88193C39.0575 9.88193 40.0114 9.65438 40.519 9.19928C41.0266 8.74418 41.2805 8.02652 41.2805 7.04631C41.2805 6.04859 41.0179 5.36594 40.4928 4.99836C39.9677 4.63078 39.0487 4.44699 37.7359 4.44699H34.664V9.88193H37.6572Z"
      fill="#FF692E"
    />
    <path
      d="M83.9224 7.72913L78.9601 17.7588H76.5183L71.5822 7.72913V19.2817H67.4863V0.928881H73.0263L77.7523 11.0111L82.5046 0.928881H88.0184V19.2817H83.9224V7.72913Z"
      fill="#FF692E"
    />
    <path
      d="M105.612 19.2817L103.906 15.3171H96.2128L94.5062 19.2817H90.1477L98.077 0.928881H102.042L109.971 19.2817H105.612ZM100.072 6.39008L97.7619 11.72H102.357L100.072 6.39008Z"
      fill="#FF692E"
    />
    <path
      d="M118.539 4.47341V19.2817H114.443V4.47341H109.245V0.928881H123.738V4.47341H118.539Z"
      fill="#FF692E"
    />
    <path
      d="M138.136 0.928881H142.232V19.2817H138.136V12.0613H130.837V19.2817H126.741V0.928881H130.837V8.59557H138.136V0.928881Z"
      fill="#FF692E"
    />
    <path
      d="M152.648 4.10583C151.966 4.10583 151.423 4.27212 151.021 4.60469C150.635 4.91976 150.443 5.34861 150.443 5.89122C150.443 6.41634 150.679 6.83643 151.152 7.1515C151.642 7.46657 152.753 7.8429 154.486 8.2805C156.237 8.70059 157.593 9.33948 158.556 10.1972C159.519 11.0549 160 12.3064 160 13.9517C160 15.5971 159.379 16.9362 158.136 17.9689C156.911 18.9841 155.291 19.4917 153.279 19.4917C150.373 19.4917 147.756 18.4152 145.428 16.2623L147.87 13.2691C149.848 15.002 151.677 15.8684 153.357 15.8684C154.11 15.8684 154.696 15.7109 155.116 15.3958C155.554 15.0632 155.773 14.6256 155.773 14.083C155.773 13.5229 155.545 13.0853 155.09 12.7702C154.635 12.4377 153.734 12.1051 152.386 11.7725C150.25 11.2649 148.684 10.6085 147.686 9.80334C146.706 8.98065 146.216 7.70287 146.216 5.96999C146.216 4.21961 146.837 2.87181 148.08 1.9266C149.34 0.981393 150.907 0.508789 152.78 0.508789C154.005 0.508789 155.23 0.718835 156.455 1.13893C157.681 1.55902 158.748 2.15415 159.659 2.92432L157.584 5.91748C155.992 4.70971 154.346 4.10583 152.648 4.10583Z"
      fill="#FF692E"
    />
    <path
      d="M55.6376 12.4881C55.2 12.033 54.9812 11.4816 54.9812 10.8339C54.9812 10.1863 55.2 9.64368 55.6376 9.20609C56.0927 8.75099 56.6441 8.52344 57.2917 8.52344C57.9394 8.52344 58.482 8.75099 58.9196 9.20609C59.3747 9.64368 59.6022 10.1863 59.6022 10.8339C59.6022 11.4816 59.3747 12.033 58.9196 12.4881C58.482 12.9257 57.9394 13.1445 57.2917 13.1445C56.6441 13.1445 56.0927 12.9257 55.6376 12.4881Z"
      fill="#FF692E"
    />
  </svg>
)

export default SvgLogoIcon
